/**
 * Build-time env vars baked into the Vite bundle. Populated by
 * scripts/fetch-web-env.sh dev (or the GitHub workflow at deploy time).
 *
 * All vars are required — the SPA has no sensible default for any of
 * these, and a missing value would cause a confusing runtime error
 * inside Amplify or the API client. Failing loudly at module-load time
 * is safer.
 */

function required(name: string): string {
  const value = (import.meta.env as Record<string, string | undefined>)[name];
  if (!value || value.length === 0) {
    throw new Error(
      `Missing required env var: ${name}. Run \`./scripts/fetch-web-env.sh ${
        (import.meta.env as Record<string, string | undefined>)["VITE_HEARTH_ENV"] ?? "dev"
      }\` to populate web/.env.development.local from SSM.`,
    );
  }
  return value;
}

function optional(name: string): string | undefined {
  const value = (import.meta.env as Record<string, string | undefined>)[name];
  return value && value.length > 0 ? value : undefined;
}

export const env = {
  hearthEnv: required("VITE_HEARTH_ENV"),
  awsRegion: required("VITE_AWS_REGION"),
  apiBaseUrl: required("VITE_API_BASE_URL"),
  cognitoUserPoolId: required("VITE_COGNITO_USER_POOL_ID"),
  cognitoUserPoolClientId: required("VITE_COGNITO_USER_POOL_CLIENT_ID"),
  // Optional — falsy when the AI stack hasn't been deployed yet (Phase
  // 8.1+ provides this). The SPA hides AI features when missing.
  aiChatStreamUrl: optional("VITE_AI_CHAT_STREAM_URL"),
} as const;

export type HearthEnv = typeof env;
